import { render, staticRenderFns } from "./platformsSetting.vue?vue&type=template&id=6a70e543&scoped=true"
import script from "./platformsSetting.vue?vue&type=script&lang=js"
export * from "./platformsSetting.vue?vue&type=script&lang=js"
import style0 from "./platformsSetting.vue?vue&type=style&index=0&id=6a70e543&prod&scoped=true&lang=css"
import style1 from "./platformsSetting.vue?vue&type=style&index=1&id=6a70e543&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a70e543",
  null
  
)

export default component.exports